import React, { memo } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import TextField from '@material-ui/core/TextField';
import GridItem from 'components/Grid/GridItem';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import PaymentIcon from '@material-ui/icons/Payment';

function PaymentAccountHeader(props) {
  const { zones } = props;
  const { payment, setPayment } = props;
  const { processing, paymentMethod, processingDocument } = props;
  const { processMultiple, selectionModel, aviableAccounts } = props;

  const { onImport, importDocumentData, setImportDocumentData } = props;
  
  async function cancelImport(e) {
    setImportDocumentData([]);
  }

  return (
    importDocumentData && importDocumentData.length > 0 ? (
      <GridContainer justify="flex-end">
        <GridItem xs={6} lg={2}>
          <Button
            fullWidth
            color="warning"
            onClick={cancelImport}
            >
            <PaymentIcon /> Cancelar Importe
          </Button>
        </GridItem>
        <GridItem xs={6} lg={2}>
          <Button
            fullWidth
            onClick={() => processMultiple(selectionModel, aviableAccounts)}
            color="success"
            disabled={processingDocument}
          >
            <PaymentIcon /> Procesar Registros
          </Button>
        </GridItem>
      </GridContainer>
    ) : (
    <GridContainer>
      <GridItem xs={12} md={4} lg={3}>
        <TextField
          fullWidth
          required
          label="En favor de"
          value={payment.CardName || ''}
          onInput={(e) => {
            let CardName = e.target.value;
            setPayment((payment) => ({ ...payment, CardName }));
          }}
        />
      </GridItem>
      <GridItem xs={12} md={4} lg={3}>
        <TextField
          fullWidth
          required
          label="Pagar a"
          value={payment.Address || ''}
          onInput={(e) => {
            let Address = e.target.value;
            setPayment((payment) => ({ ...payment, Address }));
          }}
        />
      </GridItem>
      <GridItem xs={12} md={4} lg={3}>
        <FormControl fullWidth required>
          <InputLabel>Zona</InputLabel>
          <Select
            onChange={(e) => {
              let base_zone_id = e.target.value;
              setPayment((payment) => ({ ...payment, base_zone_id }));
            }}
            value={payment.base_zone_id || ''}
            required
          >
            {zones.map((zone) => {
              return (
                <MenuItem value={zone.id} key={zone.id}>
                  {zone.description}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridContainer justify="flex-end">
        <GridItem xs={6} lg={2}>
          <Button
            fullWidth
            type="submit"
            form="formProcess"
            color="success"
            disabled={processing || paymentMethod === null}
          >
            <PaymentIcon /> Procesar
          </Button>
        </GridItem>
        <GridItem xs={6} lg={2}>
          <Button
            fullWidth
            color="info"
            onClick={onImport}
          >
            <PaymentIcon /> Importar excel Documentos
          </Button>
        </GridItem>
      </GridContainer>
    </GridContainer>
    )
  );
}

export default memo(PaymentAccountHeader);
